<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-12 mb-3">
        <div class="d-flex align-items-center justify-content-center justify-content-md-end filtro-data">
          <date-range-picker
            ref="picker"
            :auto-apply="true"
            opens="left"
            v-model="dateRange"
            :locale-data="dateRangeLocale"
            :ranges="filtrosDateRangePredefinidos"
            @update="atualizarDashboard">
          </date-range-picker>
        </div>
      </div>
    </div>
    <div class="indicadores">
      <div class="row num-dash my-5">
        <div class="col-12 col-md-4 text-center mb-4 mb-md-0">
          <p><i class="far fa-play-circle"></i>{{ tempoVideosAssistidos }}</p>
          <p>vídeo assistidos</p>
        </div>
        <div class="col-12 col-md-4 text-center mb-4 mb-md-0">
          <p><i class="fas fa-list-ul"></i>{{ questoesRespondidas }}</p>
          <p>questões respondidas</p>
        </div>
        <div class="col-12 col-md-4 text-center mb-4 mb-md-0">
          <p><i class="fas fa-cloud-download-alt"></i>{{ totalDownloads }}</p>
          <p>downloads</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6 pr-md-5 mb-3" ref="chartTopicosConcluidosContainer">
        <div class="grafico">
          <h2><i class="fas fa-chart-bar"></i> Tópicos concluídos</h2>
          <div class="ct-major-eleventh mt-3" id="chart1"></div>
        </div>
      </div>
      <div class="col-12 col-md-6 pr-md-5 mb-3" ref="chartAcessoContainer">
        <div class="grafico">
          <div class="d-flex justify-content-between align-items-center">
            <h2><i class="fas fa-chart-bar"></i> Acesso</h2>
            <div class="form-group">
              <label for="graf2">visualizar por&nbsp;</label>
              <select id="graf2" v-model="visualizacaoGraficoAcesso" @change="handleChangeGraficoTipoVisualizacao">
                <option value="disciplinas">Disciplina</option>
                <option value="cursos">Curso</option>
                <option value="modulos">Módulo</option>
                <option value="licoes">Lição</option>
              </select>
            </div>
          </div>
          <div class="ct-major-eleventh mt-3" id="chart2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'chartist/dist/chartist.min.css'
import Chartist from 'chartist'
import DateUtils from '@/core/util/date-utils'
import DashboardAPI from '@/api/dashboard-api'
import AxiosConfig from '@/config/axios-config'
import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker'
import moment from 'moment'
import ResponseUtils from '@/core/util/response-utils'

require('chartist-plugin-legend')

export default {
  name: 'DashboardGeral',
  components: { DateRangePicker },
  data () {
    return {
      visualizacaoGraficoAcesso: 'disciplinas',
      tempoVideosAssistidos: 0,
      questoesRespondidas: 0,
      totalDownloads: 0,
      dateRange: {
        startDate: DateUtils.formatDate(DateUtils.create().subtract(30, 'days').toDate()),
        endDate: DateUtils.formatDate(new Date())
      },
      filtrosDateRangePredefinidos: {
        'Esta semana': [moment().startOf('week'), moment().endOf('week')],
        'Última semana': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
        'Este mês': [moment().startOf('month'), moment().endOf('month')],
        'Último mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Este ano': [moment().startOf('year'), moment().endOf('year')]
      },
      dateRangeLocale: {
        direction: 'ltr',
        format: 'DD/MM/YYYY',
        separator: ' - ',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
      }
    }
  },
  methods: {
    carregarGraficos: function () {
      AxiosConfig.cancelAll()

      DashboardAPI.obterQuantidadeDownloadsRealizados(this.dateRange.startDate, this.dateRange.endDate).then(data => {
        this.totalDownloads = data.quantidade_downloads
      })
      DashboardAPI.obterTotalHorasVideosAssistidos(this.dateRange.startDate, this.dateRange.endDate).then(data => {
        this.tempoVideosAssistidos = data.horas + 'H' + data.minutos
      })
      DashboardAPI.obterQuantidadeQuestoesRespondidas(this.dateRange.startDate, this.dateRange.endDate).then(data => {
        this.questoesRespondidas = data.quantidade_questoes
      })

      this.handleChangeGraficoTipoVisualizacao()
      this.carregarGraficoTopicosConcluidos()
    },

    carregarGraficoTopicosConcluidos: function () {
      const loader = this.$loading.show({ isFullPage: false, loader: 'spinner', container: this.$refs.chartTopicosConcluidosContainer })

      DashboardAPI.obterQuantidadeTopicosConcluidos(this.dateRange.startDate, this.dateRange.endDate).then(data => {
        if (data && data.topicos_concluidos && data.topicos_concluidos.length) {
          const labels = data.topicos_concluidos.map(item => item.data)
          const series = data.topicos_concluidos.map(item => item.total)

          Chartist.Bar('#chart1', { labels: labels, series: [ series ] }, { axisY: { onlyInteger: true } })
        }
      }).then(() => loader.hide())
    },

    handleChangeGraficoTipoVisualizacao: function () {
      if (this.visualizacaoGraficoAcesso === 'disciplinas') {
        this.carregarGraficoAcessoDisciplina()
      } else if (this.visualizacaoGraficoAcesso === 'cursos') {
        this.carregarGraficoAcessoCurso()
      } else if (this.visualizacaoGraficoAcesso === 'modulos') {
        this.carregarGraficoAcessoModulo()
      } else if (this.visualizacaoGraficoAcesso === 'licoes') {
        this.carregarGraficoAcessoLicao()
      }
    },

    carregarGraficoAcessoDisciplina: function () {
      const quantidadeAcessosDisciplinas = DashboardAPI.obterQuantidadeAcessosDisciplinas(this.dateRange.startDate, this.dateRange.endDate).then(data => {
        return data.acessos_por_disciplinas.map(item => {
          return { label: item.disciplina, serie: item.total_acessos }
        })
      })

      this.carregarGraficoAcessoPorTipoVisualizacao(quantidadeAcessosDisciplinas)
    },

    carregarGraficoAcessoCurso: function () {
      const quantidadeAcessosCursos = DashboardAPI.obterQuantidadeAcessosCursos(this.dateRange.startDate, this.dateRange.endDate).then(data => {
        return data.acessos_por_cursos.map(item => {
          return { label: item.curso, serie: item.total_acessos }
        })
      })

      this.carregarGraficoAcessoPorTipoVisualizacao(quantidadeAcessosCursos)
    },

    carregarGraficoAcessoModulo: function () {
      const quantidadeAcessosModulos = DashboardAPI.obterQuantidadeAcessosModulos(this.dateRange.startDate, this.dateRange.endDate).then(data => {
        return data.acessos_por_modulos.map(item => {
          return { label: item.modulo, serie: item.total_acessos }
        })
      })

      this.carregarGraficoAcessoPorTipoVisualizacao(quantidadeAcessosModulos)
    },

    carregarGraficoAcessoLicao: function () {
      const quantidadeAcessosLicoes = DashboardAPI.obterQuantidadeAcessosLicoes(this.dateRange.startDate, this.dateRange.endDate).then(data => {
        return data.acessos_por_licoes.map(item => {
          return { label: item.licao, serie: item.total_acessos }
        })
      })

      this.carregarGraficoAcessoPorTipoVisualizacao(quantidadeAcessosLicoes)
    },

    carregarGraficoAcessoPorTipoVisualizacao: function (promiseRequest) {
      const limite = 5

      const loader = this.$loading.show({
        isFullPage: false,
        loader: 'spinner',
        container: this.$refs.chartAcessoContainer
      })

      promiseRequest.then(data => {
        if (data.length) {
          if (data.length > limite) {
            data = data.slice(0, 5)
          }
          const labels = data.map(item => item.label)
          const series = data.map(item => item.serie)

          Chartist.Bar('#chart2', {
            labels: labels,
            series: series
          }, {
            distributeSeries: true,
            axisX: {
              offset: 35
            }
          })
        }
      }).catch(error => ResponseUtils.handleError(error, loader))
        .then(() => loader.hide())
    },

    atualizarDashboard: function () {
      this.dateRange.startDate = DateUtils.formatDate(this.dateRange.startDate)
      this.dateRange.endDate = DateUtils.formatDate(this.dateRange.endDate)

      this.carregarGraficos()
    }
  },
  mounted () {
    this.carregarGraficos()
  },

  destroyed () {
    AxiosConfig.cancelAll()
  }
}
</script>

<style scoped>

</style>
